import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ApprovalServiceInvoiceLineItems from "./View";
import { getValetItemLineInvoiceId, lineItemsApprovalRejection } from "../../../../../services/redux/sales/postSales/action";
import {getServiceInvoiceList} from "services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    lineItemsByInvoiceId: state.postSalesReducer.lineItemsByInvoiceId,
    lineItemsApprovalRejectionResponse: state.postSalesReducer.lineItemsApprovalRejectionResponse,
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetItemLineInvoiceId,
            lineItemsApprovalRejection,
            getServiceInvoiceList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalServiceInvoiceLineItems);
